import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
        <PageHeader {...page}> Discounts</PageHeader>
        <SwitchRow {...page}  keyName= {LocationVarKey.HasDiscountCustom} label="Custom"/>
        <SwitchRow {...page}  keyName= {LocationVarKey.HasDiscountIntroductory} label="Introductory"/>
        <SwitchRow {...page}  keyName= {LocationVarKey.HasDiscountLongTerm} label="Long Term"/>
        <SwitchRow {...page}  keyName= {LocationVarKey.HasDiscountMilitary} label="Military"/>
        <SwitchRow {...page}  keyName= {LocationVarKey.HasDiscountSenior} label="Senior"/>
        <SwitchRow {...page}  keyName= {LocationVarKey.HasDiscountStudent} label="Student"/>

        <SectionHeader {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDiscountCustom,"1")}> Custom Discounts </SectionHeader>
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDiscountCustom,"1")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.DiscountCustomDiscount1}
        />

        <SectionHeader {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDiscountIntroductory,"1")}> Introductory Discounts / Rates </SectionHeader>
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDiscountIntroductory,"1")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.DiscountIntroductory1}
        />
    
        <SectionHeader {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDiscountLongTerm,"1")}> Long Term Discounts </SectionHeader>
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDiscountLongTerm,"1")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.DiscountLongTerm1}
        />


        <SectionHeader {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDiscountMilitary,"1")}> Military Discounts </SectionHeader>
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDiscountMilitary,"1")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.DiscountMilitary1}
        />

        <SectionHeader {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDiscountSenior,"1")} > Senior Discounts </SectionHeader>
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDiscountSenior,"1")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.DiscountSenior1}
        />

        <SectionHeader {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDiscountStudent,"1")}> Student Discounts </SectionHeader>
        <TextAreaRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.HasDiscountStudent,"1")}
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.DiscountStudent1}
        />

        
        
    
    </>
}